import React from "react";
import { diffDate } from "../../../../helpers/helper";

const PaymentDetail = ({ formData, val, match }) => {
  const { checkOut, checkIn } = formData;

  return (
    <>
      <div className="price-summary-wrap hotel-price-summary">
        {console.log({ match })}
        {match === undefined || match?.length === 0 ? (
          <div class="row mt-3 w-100 p-3">
            <div class="col-lg-12">
              <span class="loader-bg p-3 mb-2 d-block w-25 rounded"></span>
              <span class="loader-bg p-3 mb-2 d-block w-50 rounded"></span>
              <span class="loader-bg pt-4 mb-2 d-block w-75 me-2 rounded"></span>
              <span class="loader-bg pt-4 mb-2 d-block w-50 me-2 rounded"></span>
            </div>
          </div>
        ) : (
          <>
            <ul>
              <h5 className="b-b-20">Price Summary</h5>
              <li>
                <p className="medium16">
                  Room Charges ({diffDate(checkOut, checkIn)} Nights)
                </p>
                <p className="medium16">
                  $ {parseFloat(match?.TotalFare - match?.TotalTax).toFixed(2)}
                </p>
              </li>
            </ul>
            <ul>
              <h5 className="b-b-16">+Taxes & Fees</h5>
              <li>
                <p className="medium16">Hotel Taxes</p>
                <p className="medium16">$ {match?.TotalTax}</p>
              </li>
              <li>
                <p className="medium16">Service Fee</p>
                <p className="medium16">FREE</p>
              </li>
              <li>
                <p className="r-b-16">Total Amount to be Paid</p>
                <p className="r-b-16">$ {match?.TotalFare}</p>
              </li>
            </ul>
          </>
        )}
      </div>
    </>
  );
};

export default PaymentDetail;
